import axios from "axios";

export const GET_ALL = "doctors";
export const SAVE = "doctors";
export const UPDATE = "doctors";
export const DELETE = "doctors";


export let getAll = function (status) {
  return axios.get(`${GET_ALL}`);
}

export let save = function (data) {
  return axios.post(SAVE, data);
}

export function update(data, id) {
  return axios.put(`${UPDATE}/${id}`, data);
}

export function destroy(id) {
  return axios.delete(`${DELETE}/${id}`);
}